"use client";

import { DataTablePagination } from "@/components/data-table-pagination";
import { useDataTable } from "@/hooks/use-data-table";
import { DataTable } from "@/lib/data-table";
import { organizationCompaniesPath } from "@/routes";
import type { Company, PagyMetadata, RansackFilters } from "@/types";

import { buildColumns } from "./columns";

interface CompaniesDataTableProps {
  companies: Company[];
  pagy: PagyMetadata;
  filters: RansackFilters;
  organizationSlug: string;
}

export function CompaniesDataTable({
  companies,
  pagy,
  filters,
  organizationSlug,
}: CompaniesDataTableProps) {
  const {
    isLoading,
    handlePageChange,
    handleSortingChange,
    getSortingState,
  } = useDataTable({
    filters,
    pagy,
    path: organizationCompaniesPath(organizationSlug),
  });
  const columns = buildColumns(organizationSlug);

  return (
    <div className="space-y-4">
      <div className={isLoading ? "opacity-50" : ""}>
        <DataTable
          columns={columns}
          data={companies}
          sorting={getSortingState()}
          onSortingChange={handleSortingChange}
          manualSorting={true}
          manualPagination={true}
          pageCount={pagy.pages}
          pagination={false}
        />
      </div>

      <DataTablePagination
        pagy={pagy}
        isLoading={isLoading}
        onPageChange={handlePageChange}
        entityName="compañías"
      />
    </div>
  );
}
